import ProfileDataStore from '../../datastores/ProfileDataStore';

export default class ProfileDataStoreMock implements ProfileDataStore {
  getProfileAcl() {
    throw new Error('Method not implemented.');
  }

  async getStudentType() {
    throw new Error('Method not implemented.');
  }

  async getEmailAndPhone() {
    return {
      email: {
        hasEditingPermissionEmail: true,
        email: 'IVAN.ENCISO@ULMEN.CL',
        type: 'HOME',
        principal: '1'
      },
      phone: {
        hasEditingPermissionPhone: true,
        phoneNumber: '51999009872',
        type: 'CELL',
        principal: '1'
      }
    };
  }

  async validateCodeByType() {
    throw new Error('Method not implemented.');
  }

  async getProfileTurnByPeriod() {
    throw new Error('Method not implemented.');
  }

  async getProfile(): Promise<any> {
    const data = {
      student: {
        academic: {
          period: {
            id: 2212,
            description: '2021-Ciclo 1 Marzo'
          },
          career: 'PPE',
          campus: 'CHICL',
          campusDesc: 'Campus Chiclayo lima',
          isProvince: false,
          isCGT: true,
          plan: 'SIST2020',
          prog: 'PSIST'
        },
        profile: {
          lastName: 'Cardozo Sanchez',
          firstName: 'Roberto Armando',
          studentCode: 'U21200258',
          peopleCode: '00001352530',
          dni: '72175685'
        }
      }
    };

    return { profile: data.student.profile, academic: data.student.academic };
  }

  async getProfilePhoto(): Promise<any> {
    return 'base64';
  }

  async getModalityOfStudy(): Promise<any> {
    return {
      code: 'MOD',
      desc: 'modalidad presencial',
      campus: 'LIMA'
    };
  }

  async getProfileTurn(): Promise<any> {
    return {
      procedures: {
        modalityOfStudy: {
          desc: 'semipresencial - CGT'
        }
      },
      profile: {
        firstName: 'JORGE ERICKSON'
      },
      enrolmentAppointment: {
        date: '1640611200000',
        endEnrolmentText: '29 Dic 2022',
        enrolmentEnabled: false,
        enrolmentPayment: {
          assuranceAmount: null,
          assuranceText: 'P. Salud estudiantil',
          enrolmentAmount: null,
          enrolmentText: 'Matrícula',
          pendingFeeAmount: null,
          pendingFeeText: 'Cuotas pendientes'
        },
        periodDesc: 'Ciclo - Verano 2023',
        startClassText: '09 Ene 2023',
        studentType: 'REINSCRITO',
        textDate: 'Lunes, 27 Dic 2021',
        textHour: '13:20 hrs',
        url: 'https://www.utp.edu.pe/matricula',
        whatsapp: '960252970'
      }
    };
  }

  async getProfileData() {
    throw new Error('Method not implemented.');
  }

  async getProfileMastersData() {
    throw new Error('Method not implemented.');
  }

  sendValidationCode(...attrs: any[]): any {
    return attrs;
  }

  updateDataProfile(...attrs: any[]): any {
    return attrs;
  }

  updateProfile(...attrs: any[]): any {
    return attrs;
  }

  async getPeriods(): Promise<any> {
    return [
      {
        id: '2233',
        description: '2023 - Ciclo 2 Agosto'
      }
    ];
  }
}
